export default "__VITE_ASSET__CXZxpWLd__"